export const BARCODE_OPTIONS = {
  color: {
    dark: '#000000FF',
    light: '#FFFFFFFF',
  },
};
